export const HEADER = $localize`INDICATORS`;
export const INDICATORS = [
  [
    { id: '001', name: $localize`Direct To Retail` },
    { id: '002', name: $localize`Not In One ADL` },
    { id: '003', name: $localize`Click and Collect` },
    { id: '004', name: $localize`Retail to Retail` },
    { id: '005', name: $localize`Pickup` },
  ],
  [
    { id: '006', name: $localize`Drop Off` },
    { id: '007', name: $localize`PUDO` },
    { id: '008', name: $localize`Delivery Time` },
    { id: '009', name: $localize`Accepts Prepaid Dropoffs` },
    { id: '010', name: $localize`DCO DCR Intercept Accepted` },
  ],
  [
    { id: '011', name: $localize`Can Collect Funds` },
    { id: '012', name: $localize`Pay At Store` },
    { id: '013', name: $localize`Accepts Restricted Articles` },
    { id: '014', name: $localize`Accepts My Choice` },
    { id: '015', name: $localize`Accepts Mobile Dropoff` },
  ],
];
